<template>
  <el-dialog :visible.sync="dialogVisible" width="880px" append-to-body>
    <div class="login-wrapper e-flex">
      <div class="login-left">
  <div class="block">
    <el-carousel height="600px">
      <el-carousel-item v-for="item in images" :key="item">
              <img :src="item" style="width: 100%" />
      </el-carousel-item>
    </el-carousel>
  </div>
      </div>
      <div class="login-right">
        <phone-login v-if="isPhoneLogin"></phone-login>
        <user-login v-else></user-login>
        <!-- <div class="login-or">或</div>
        <div>
          <el-button
            type="success"
            style="width: 100%"
            @click="changeLoginType"
          >
            {{ isPhoneLogin ? '账号登录' : '手机验证码登录' }}
          </el-button>
        </div> -->
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PhoneLogin from './components/PhoneLogin'
import UserLogin from './components/UserLogin'
export default {
  components: {
    PhoneLogin,
    UserLogin,
  },
  data() {
    return {
      isPhoneLogin: true, // 默认手机验证码登录
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.$store.state.user.loginVisible
      },
      set(newValue) {
        this.$store.commit('user/SET_LOGINVISIBLE', newValue)
      },
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
    images() {
      if (this.isBsgzw) {
        return [this.$cdn.loginBanner.bsgzw_banner_01]
      }
      return [this.$cdn.loginBanner.banner_01]
    },
  },
  methods: {
    open() {
      this.$store.commit('user/SET_LOGINVISIBLE', true)
    },
    changeLoginType() {
      this.isPhoneLogin = !this.isPhoneLogin
    }
  },
}
</script>
<style scoped>
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 26px;
  }
  .login-wrapper {
    height: 600px;
    align-items: center;
    /* display: flex; */
  }
  .login-left {
    width: 390px;
    overflow: hidden;
  }
  .login-right {
    flex: 1;
    padding: 100px 60px;
  }
  .login-or {
    text-align: center;
    margin-bottom: 22px;
    font-size: 16px;
    color: #999;
  }
  </style>
